import { Typography, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";

const WebView = React.memo(() => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: theme.palette.primary.white,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "75vh",
        gap: 8,
      }}
    >
      <Box
        sx={{
          width: "40%",
          height: "100%",
          backgroundImage: "url(/images/home/about.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      <Box
        sx={{
          width: "55%",
          display: "flex",
          flexDirection: "column",
          marginRight: 15,
          paddingTop: 4,
          paddingBottom: 4,
          gap: 10,
        }}
      >
        <Typography
          sx={{
            color: "#000",
            fontSize: {
              xs: "2.5rem",
              sm: "3rem",
              md: "3rem",
              laptop: "3.5rem",
              lg: "4rem",
              xl: "4.25rem",
            },
          }}
          variant="h2"
        >
          About{" "}
          <span style={{ color: "#0D2B4E" }}>
            <i>Infinity Hypercloud</i>
          </span>
        </Typography>
        <Typography
          sx={{
            color: "#000",
            fontSize: {
              xs: "0.8rem",
              laptop: "0.8rem",
              lg: "1.225rem",
            },
          }}
          variant="subtitle1"
        >
          At InfinityHyperCloud, we deliver scalable digital solutions that
          drive growth, efficiency, and innovation. Specializing in SaaS
          Development, Web & Mobile App Development, and Cloud . Solutions, we
          help businesses stay ahead in a fast-evolving digital world.
          <br />
          <br />
          With expertise in Data Analytics & Business Intelligence (Without Data
          Collection), we provide actionable insights while ensuring full data
          privacy. Our focus on Performance Optimization, API Development, and
          Enterprise Digital Transformation ensures secure, scalable, and
          future-ready solutions.
          <br />
          <br />
          From seamless cloud integration to intuitive UI/UX engineering, we
          empower businesses with cutting-edge technology that enhances user
          experiences and maximizes efficiency.
        </Typography>
      </Box>
    </Box>
  );
});

const MobileView = React.memo(() => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: theme.palette.primary.white,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "80vh",
        width: "100%",
        gap: 2,
      }}
    >
      <Box
        sx={{
          width: "85%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 4,
        }}
      >
        <Typography
          sx={{
            color: "#000",
            fontSize: {
              xs: "2.5rem",
              sm: "2.25rem",
              md: "2.25rem",
              laptop: "3.5rem",
              lg: "4rem",
              xl: "4.25rem",
            },
            lineHeight: "50px",
            marginTop: 4,
            textAlign: "center",
          }}
          variant="h2"
        >
          About{" "}
          <span style={{ color: "#0D2B4E" }}>
            <i>Infinity Hypercloud</i>
          </span>
        </Typography>
        <Typography
          sx={{
            color: "#000",
            mb: 4,
            fontSize: {
              xs: "0.8rem",
              // sm: "0.8rem",
              // md: "0.8rem",
              laptop: "0.8rem",
              lg: "1.225rem",
            },
            textAlign: "center",
          }}
          variant="subtitle1"
        >
          At InfinityHyperCloud, we deliver scalable digital solutions that
          drive growth, efficiency, and innovation. Specializing in SaaS
          Development, Web & Mobile App Development, and Cloud . Solutions, we
          help businesses stay ahead in a fast-evolving digital world.
          <br />
          <br />
          With expertise in Data Analytics & Business Intelligence (Without Data
          Collection), we provide actionable insights while ensuring full data
          privacy. Our focus on Performance Optimization, API Development, and
          Enterprise Digital Transformation ensures secure, scalable, and
          future-ready solutions.
          <br />
          <br />
          From seamless cloud integration to intuitive UI/UX engineering, we
          empower businesses with cutting-edge technology that enhances user
          experiences and maximizes efficiency.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundImage: "url(/images/home/about.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
    </Box>
  );
});

const About = () => {
  const theme = useTheme();
  const isMdScreen = useMediaQuery(theme.breakpoints.up("md"));

  return !isMdScreen ? <MobileView /> : <WebView />;
};

export default About;
